import React, { useState, useEffect } from "react";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import "./block_user.css";
import Api from "../../api";
import Modal from "../Modal";
import CheckInput from "../CheckInput";
import Select from "../Select";
import {
  DOCUMENT_TYPES,
  MONTHLY_INTENSITY,
  LANGUAGES,
  ROL_OPTIONS,
} from "../../consts";

const Block_user = () => {
  const defaultUser = {
    customer_id: "",
    customer_id_type: "",
    first_name: "",
    middle_name: "",
    maternal_last_name: "",
    paternal_last_name: "",
    contract_expiration: "",
    monthly_intensity: "",
    block_acc: false,
    academic: false,
    payments: false,
    email: "",
    roles: [],
  };

  const [showModal, setShowModal] = useState(false);
  const [userFound, setUserFound] = useState(null);
  const [userData, setUserData] = useState(defaultUser);

  const handleSearchUser = async () => {
    try {
      const data = await Api.User.GetById({
        customer_id: userData.customer_id,
      });
      showNotification("¡Exito!", "Usuario encontrado", "success");
      setUserFound(true);
      setUserData({ ...defaultUser, ...data });
      console.log("This is the userData (raw):", data);
      try {
        console.log("This is the userData (json):", JSON.stringify(data, null, 2));
      } catch (e) {
        console.log("Could not stringify user data", e);
      }
      console.log("userData keys:", Object.keys(data || {}));
    } catch (error) {
      showNotification("Error", error.message, "warning");
    }
  };

  useEffect(() => {
    if (userData) {
      console.log("userData state updated:", userData);
      console.log("userData state keys:", Object.keys(userData || {}));
    }
  }, [userData]);

  const updateUserReq = async () => {
    const roles = userData.roles || [];
    const isStudent = roles.includes("ROLE_STUDENT");
    const isAdminOrTeacher = roles.some((r) =>
      ["ROLE_ADMIN", "ROLE_TEACHER"].includes(r)
    );
    const canBlockAcc = isStudent || isAdminOrTeacher;

    if (!canBlockAcc) {
      showNotification(
        "Aviso",
        "El rol del usuario no permite modificar bloqueos",
        "warning"
      );
      return;
    }

    const payload = {
      customer_id: userData.customer_id,
      block_acc: !!userData.block_acc,
    };

    if (isStudent) {
      payload.academic = !!userData.academic;
      payload.payments = !!userData.payments;
      payload.contract_expiration = userData.contract_expiration;
      payload.monthly_intensity = userData.monthly_intensity;
    }

    try {
      const data = await Api.User.UpdateProperties(payload);
      showNotification("¡Exito!", "Usuario actualizado", "success");
      setShowModal(false);
    } catch (error) {
      showNotification("Error", error.message, "danger");
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  const ModalContent = () => {
    return (
      <p>
        ¿Está seguro que desea cambiar el estado de bloqueo del usuario{" "}
        {userData.customer_id}?
      </p>
    );
  };

  const roles = userData.roles || [];
  const isStudent = roles.includes("ROLE_STUDENT");
  const isAdminOrTeacher = roles.some((r) =>
    ["ROLE_ADMIN", "ROLE_TEACHER"].includes(r)
  );
  const canBlockAcc = isStudent || isAdminOrTeacher;

  return (
    <>
      <div className="pace-register_container">
        <h1>Bloquear usuario</h1>

        <form className="form-register">
          <div className="searchUser">
            <h4>Ingrese la identificacion del usuario que desea modificar</h4>
            <input
              className="customer_id"
              type="text"
              id="customer_id-search"
              placeholder="Identificacion"
              value={userData.customer_id}
              onChange={(e) =>
                setUserData({ ...userData, customer_id: e.target.value })
              }
            />

            <div className="submit-buttons-container">
              <button
                className="button-search_user"
                type="button"
                onClick={handleSearchUser}
              >
                Buscar Usuario
              </button>
            </div>
          </div>

          {userFound && (
            <>
              <div className="pair-container">
                <div className="customer-id_container">
                  Número de identificacion
                  <input
                    className="customer_id"
                    type="number"
                    id="customer_id"
                    placeholder="Identificacion"
                    value={userData.customer_id}
                    disabled={true}
                  />
                </div>

                <div className="customer_id_type">
                  Tipo de documento de identidad
                  <Select
                    name="customer_id_type"
                    options={DOCUMENT_TYPES}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={DOCUMENT_TYPES.find(
                      (dc) => dc.value === userData.customer_id_type
                    )}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Primer nombre
                  <input
                    type="text"
                    id="first_name"
                    placeholder="Primer nombre"
                    value={userData.first_name}
                    disabled={true}
                  />
                </div>

                <div className="customer_id_type">
                  Segundo nombre
                  <input
                    type="text"
                    id="middle_name"
                    placeholder="Segundo nombre"
                    value={userData.middle_name}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Primer apellido
                  <input
                    type="text"
                    id="paternal_last_name"
                    placeholder="Primer apellido"
                    value={userData.paternal_last_name}
                    disabled={true}
                  />
                </div>

                <div className="customer_id_type">
                  Segundo apellido
                  <input
                    type="text"
                    id="maternalLastName"
                    placeholder="Segundo apellido"
                    value={userData.maternal_last_name}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Fecha expiracion del contrato (Estudiante)
                  <input
                    className="contract_expiration"
                    type="date"
                    id="contract_expiration"
                    name="contract_expiration"
                    value={userData.contract_expiration}
                    disabled={!isStudent}
                    onChange={(e) =>
                      setUserData({
                        ...userData,
                        contract_expiration: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="customer_id_type">
                  Intensidad mensual en horas (Estudiante)
                  <Select
                    name="monthly_intensity"
                    options={MONTHLY_INTENSITY}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={MONTHLY_INTENSITY.find(
                      (dc) => dc.value === userData.monthly_intensity
                    )}
                    isDisabled={!isStudent}
                    onChange={(selected) => {
                      if (!selected) return;
                      setUserData({
                        ...userData,
                        monthly_intensity: selected.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Lenguaje (Profesor)
                  <Select
                    name="language"
                    options={LANGUAGES}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={LANGUAGES.find(
                      (dc) => dc.value === userData.language
                    )}
                    disabled={true}
                  />
                </div>

                <div className="customer_id_type">
                  Correo
                  <input
                    type="email"
                    id="email"
                    value={userData.email}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Roles
                  <Select
                    isMulti
                    name="roles"
                    options={ROL_OPTIONS}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={ROL_OPTIONS.filter((rol) =>
                      userData.roles.some((r) => r === rol.value)
                    )}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer_id_type">
                  Bloqueos (por defecto sin bloqueo)
                  {canBlockAcc ? (
                    <>
                      <div className="block-row">
                        <label>Sesión completa</label>
                        <CheckInput
                          isToggled={!!userData.block_acc}
                          onToggle={() => {
                            setUserData({
                              ...userData,
                              block_acc: !userData.block_acc,
                            });
                          }}
                        />
                      </div>
                      {isStudent && (
                        <>
                          <div className="block-row">
                            <label>Académico</label>
                            <CheckInput
                              isToggled={!!userData.academic}
                              onToggle={() => {
                                setUserData({
                                  ...userData,
                                  academic: !userData.academic,
                                });
                              }}
                            />
                          </div>
                          <div className="block-row">
                            <label>Pagos</label>
                            <CheckInput
                              isToggled={!!userData.payments}
                              onToggle={() => {
                                setUserData({
                                  ...userData,
                                  payments: !userData.payments,
                                });
                              }}
                            />
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <p>El rol del usuario no permite configurar bloqueos.</p>
                  )}
                </div>
              </div>

              <div className="submit-buttons-container">
                <input
                  className="button_register"
                  type="button"
                  value="Actualizar"
                  onClick={(e) => {
                    setShowModal(true);
                  }}
                />
              </div>
            </>
          )}
        </form>
      </div>

      {showModal && (
        <Modal
          isOpen={showModal}
          title="Bloquear a usuario"
          Content={ModalContent}
          onCancel={(e) => {
            setShowModal(false);
          }}
          onSubmit={updateUserReq}
        />
      )}
    </>
  );
};

export default Block_user;
